import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import '../../css/SingleScreens/ConsultationStartScreen.css';
import { StringUtils, ArrayUtils } from '../../utils';
import { History as history, Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ConsultationsActions, ToastActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Switch, Header, Line, Input } from  '../../components'

class ConsultationStartScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_client: null,
      selected_patient: null,
      selected_provider: null,
      selected_location: null,
      subject: '',
      description: '',
      noCharge: false,
      display_modal: false,
      locations: [],
      provider_locations: [],
      roles: [],
      client_search_term: '',
      client_search_results: [],
      client_patients: [],
    }
  }

  componentDidMount() {
    let practice_id = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';
    let token       = this.props.user    && this.props.user.auth && this.props.user.auth.token   ? this.props.user.auth.token   : '';
    let user_id     = this.props.user    && this.props.user.auth && this.props.user.auth.user_id ? this.props.user.auth.user_id : '';

    if (practice_id && token) {
      this.props.practiceActions.getPracticeLocations(token, practice_id, this.setLocations);
    }

    if (user_id && token) {
      this.props.consultationsActions.getProviderRolesAndLocations(token, user_id, practice_id, this.setRoles, this.setProviderLocations);
    }

    this.setState({ ...this.state, token: token, practice_id: practice_id });
  }

  renderLocationSection = () => {
    let selected_location = this.state.selected_location;
    let is_selected       = selected_location !== null && selected_location._id ? true : false;
    let icon_class    = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
    let icon_color    = is_selected ? '#1dc2ff' : '#e7e7e7';
    let location_name = is_selected ? selected_location.name : 'Select a Location';
    let btn_title     = is_selected ? 'CHANGE' : 'SELECT';
    let row_class     = 'flex-container-row standard-selection-row';
    let name_color    = is_selected ? '#575757' : 'grey';
    return <div className={row_class}
                style={{ alignItems: 'center', justifyContent: 'space-between', padding: 15 }}
                onClick={ () => { this.setState({ ...this.state, display_modal: true, modal_type: 'location' }) }}>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        <span className={icon_class} style={{ fontSize: 20, marginRight: 10, color: icon_color }}/>
        <span style={{ color: name_color, fontSize: 14 }}>{ location_name }</span>
      </div>
      <div>
        <span style={{ fontSize: 12, color: '#1dc2ff', fontWeight: 'bold' }}>{ btn_title }</span>
      </div>
    </div>
  }

  renderClientSection = () => {
    let is_active   = this.state.selected_location !== null && this.state.selected_location._id ? true : false;
    let is_selected = this.state.selected_client   !== null && this.state.selected_client._id   ? true : false;
    let icon_class  = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
    let icon_color  = is_selected ? '#1dc2ff' : '#e7e7e7';
    let client_name = is_selected ? StringUtils.displayName(this.state.selected_client) : 'Select a Client';
    let name_color  = is_selected ? '#575757' : 'grey';
    let btn_title   = is_selected ? 'CHANGE' : 'SELECT';
    let btn_color   = '#1dc2ff';
    let row_class   = 'flex-container-row standard-selection-row';

    if (!is_active) {
      icon_color = '#e7e7e7';
      name_color = '#e7e7e7';
      btn_color  = '#e7e7e7';
      row_class  = 'flex-container-row';
    }
    return <div className={row_class}
                style={{ alignItems: 'center', justifyContent: 'space-between', padding: 15 }}
                onClick={ () => {
                  if (is_active) {
                    this.setState({ ...this.state, display_modal: true, modal_type: 'client' })
                  }
                }}>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        <span className={icon_class} style={{ fontSize: 20, marginRight: 10, color: icon_color }}/>
        <span style={{ color: name_color, fontSize: 14 }}>{ client_name }</span>
      </div>
      <div>
        <span style={{ fontSize: 12, color: btn_color, fontWeight: 'bold' }}>{ btn_title }</span>
      </div>
    </div>
  }

  renderPatientSection = () => {
    let is_active    = this.state.selected_client  !== null && this.state.selected_client._id  ? true : false;
    let is_selected  = this.state.selected_patient !== null && this.state.selected_patient._id ? true : false;
    let icon_class   = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
    let icon_color   = is_selected ? '#1dc2ff' : '#e7e7e7';
    let patient_name = is_selected ? StringUtils.displayName(this.state.selected_patient) : 'Select a Patient';
    let name_color   = is_selected ? '#575757' : 'grey';
    let btn_title    = is_selected ? 'CHANGE' : 'SELECT';
    let btn_color    = '#1dc2ff';
    let row_class    = 'flex-container-row standard-selection-row';

    if (!is_active) {
      icon_color = '#e7e7e7';
      name_color = '#e7e7e7';
      btn_color  = '#e7e7e7';
      row_class  = 'flex-container-row';
    }
    return <div className={row_class}
                style={{ alignItems: 'center', justifyContent: 'space-between', padding: 15 }}
                onClick={ () => {
                  if (is_active) {
                    if (this.state.selected_client) {
                      this.props.consultationsActions.getClientPatients(this.state.token, this.state.selected_client._id, this.setClientPatients);
                    }
                    this.setState({ ...this.state, display_modal: true, modal_type: 'patient' });
                  }
                }}>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        <span className={icon_class} style={{ fontSize: 20, marginRight: 10, color: icon_color }}/>
        <span style={{ color: name_color, fontSize: 14 }}>{ patient_name }</span>
      </div>
      <div>
        <span style={{ fontSize: 12, color: btn_color, fontWeight: 'bold' }}>{ btn_title }</span>
      </div>
    </div>
  }

  renderProviderSection = () => {
    let is_active     = this.state.selected_patient  !== null && this.state.selected_patient._id  ? true : false;
    let is_selected   = this.state.selected_provider !== null && this.state.selected_provider._id ? true : false;
    let icon_class    = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
    let icon_color    = is_selected ? '#1dc2ff' : '#e7e7e7';
    let provider_name = is_selected ? StringUtils.displayName(this.state.selected_provider) : 'Select a Provider';
    let name_color    = is_selected ? '#575757' : 'grey';
    let btn_title     = is_selected ? 'CHANGE' : 'SELECT';
    let btn_color     = '#1dc2ff';
    let row_class     = 'flex-container-row standard-selection-row';

    if (!is_active) {
      icon_color = '#e7e7e7';
      name_color = '#e7e7e7';
      btn_color  = '#e7e7e7';
      row_class  = 'flex-container-row';
    }
    return <div className={row_class}
                style={{ alignItems: 'center', justifyContent: 'space-between', padding: 15 }}
                onClick={ () => {
                  if (is_active) {
                    let location_id = this.state.selected_location && this.state.selected_location._id ? this.state.selected_location._id : '';
                    let practice_id = this.state.practice_id;
                    if (location_id && practice_id) {
                      this.props.consultationsActions.getPracticeVeterinarians(this.state.token, location_id, practice_id, this.setEligibleProviders);
                    }
                    this.setState({ ...this.state, display_modal: true, modal_type: 'provider' })
                  }
                }}>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        <span className={icon_class} style={{ fontSize: 20, marginRight: 10, color: icon_color }}/>
        <span style={{ color: name_color, fontSize: 14 }}>{ provider_name }</span>
      </div>
      <div>
        <span style={{ fontSize: 12, color: btn_color, fontWeight: 'bold' }}>{ btn_title }</span>
      </div>
    </div>
  }

  renderSubjectSection = () => {
    let is_active     = this.state.subject || (this.state.selected_provider  !== null && this.state.selected_provider._id)  ? true : false;
    let is_selected   = this.state.subject && this.state.subject !== '' ? true : false;
    let label         = is_selected ? 'Subject Added' : 'Add Subject';
    let icon_class    = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
    let icon_color    = is_selected ? '#1dc2ff' : '#e7e7e7';
    let name_color    = is_selected ? '#575757' : 'grey';
    let btn_title     = is_selected ? 'EDIT' : 'ADD';
    let btn_color     = '#1dc2ff';
    let row_class     = 'flex-container-row standard-selection-row';

    if (!is_active) {
      icon_color = '#e7e7e7';
      name_color = '#e7e7e7';
      btn_color  = '#e7e7e7';
      row_class  = 'flex-container-row';
    }
    return <div className={row_class}
                style={{ alignItems: 'center', justifyContent: 'space-between', padding: 15 }}
                onClick={ () => {
                  if (is_active) {
                    this.setState({ ...this.state, display_modal: true, modal_type: 'subject' });
                  }
                }}>
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          <span className={icon_class} style={{ fontSize: 20, marginRight: 10, color: icon_color }}/>
          <span style={{ color: name_color, fontSize: 14 }}>{ label }</span>
        </div>
        <div>
          <span style={{ fontSize: 12, color: btn_color, fontWeight: 'bold' }}>{ btn_title }</span>
        </div>
      </div>
  }

  renderDescriptionSection = () => {
    let is_active     = this.state.description || this.state.subject ? true : false;
    let is_selected   = this.state.description && this.state.description !== '' ? true : false;
    let label         = is_selected ? 'Description Added' : 'Add Description';
    let icon_class    = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
    let icon_color    = is_selected ? '#1dc2ff' : '#e7e7e7';
    let name_color    = is_selected ? '#575757' : 'grey';
    let btn_title     = is_selected ? 'EDIT' : 'ADD';
    let btn_color     = '#1dc2ff';
    let row_class     = 'flex-container-row standard-selection-row';

    if (!is_active) {
      icon_color = '#e7e7e7';
      name_color = '#e7e7e7';
      btn_color  = '#e7e7e7';
      row_class  = 'flex-container-row';
    }
    return <div className={row_class}
                style={{ alignItems: 'center', justifyContent: 'space-between', padding: 15 }}
                onClick={ () => {
                  if (is_active) {
                    this.setState({ ...this.state, display_modal: true, modal_type: 'description' });
                  }
                }}>
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          <span className={icon_class} style={{ fontSize: 20, marginRight: 10, color: icon_color }}/>
          <span style={{ color: name_color, fontSize: 14 }}>{ label }</span>
        </div>
        <div>
          <span style={{ fontSize: 12, color: btn_color, fontWeight: 'bold' }}>{ btn_title }</span>
        </div>
      </div>
  }

  renderSummarySections = () => {
    let address_name    = this.state.selected_location && this.state.selected_location.name    ? this.state.selected_location.name  : '- - - - -';
    let address_street  = this.state.selected_location && this.state.selected_location.street_address ? this.state.selected_location.street_address : '- - - - -';
    let address_city    = this.state.selected_location && this.state.selected_location.city    ? this.state.selected_location.city  : '- - - - -';
    let address_state   = this.state.selected_location && this.state.selected_location.state   ? this.state.selected_location.state + ', ' : '';
    let address_zipcode = this.state.selected_location && this.state.selected_location.zipcode ? this.state.selected_location.zipcode  : '';

    let client_name     = StringUtils.displayName(this.state.selected_client)   || '- - - - -';
    let patient_name    = StringUtils.displayName(this.state.selected_patient)  || '- - - - -';
    let provider_name   = StringUtils.displayName(this.state.selected_provider) || '- - - - -';

    let subject         = this.state.subject     || '- - - - -';
    let description     = this.state.description || '- - - - -';

    if (subject.length > 120) {
      subject = subject.substr(0,117) + '...';
    }

    if (description.length > 120) {
      description = description.substr(0,117) + '...';
    }

    return <div className='flex-container-column' style={{ padding: 15, paddingTop: 10 }}>
      <div className='flex-container-row'>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', letterSpacing: 0.3 }}>LOCATION</span>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', flex: 1 }}>
          <span style={{ color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ address_name }</span>
          <span style={{ marginTop: -2, color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ address_street }</span>
          <span style={{ marginTop: -2, color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ address_city + ' ' + address_state + address_zipcode }</span>
        </div>
      </div>
      <div className='flex-container-row' style={{ marginTop: 15 }}>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', letterSpacing: 0.3 }}>CLIENT</span>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', flex: 1 }}>
          <span style={{ color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ client_name }</span>
        </div>
      </div>
      <div className='flex-container-row' style={{ marginTop: 15 }}>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', letterSpacing: 0.3 }}>PATIENT</span>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', flex: 1 }}>
          <span style={{ color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ patient_name }</span>
        </div>
      </div>
      <div className='flex-container-row' style={{ marginTop: 15 }}>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', letterSpacing: 0.3 }}>PROVIDER</span>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', flex: 1 }}>
          <span style={{ color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ provider_name }</span>
        </div>
      </div>

      <Line style={{ marginBottom: 15, marginTop: 15 }}/>

      <div className='flex-container-column' style={{  }}>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', letterSpacing: 0.3 }}>SUBJECT</span>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-start', flex: 1 }}>
          <span style={{ color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ subject }</span>
        </div>
      </div>
      <div className='flex-container-column' style={{ marginTop: 15 }}>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', letterSpacing: 0.3 }}>DESCRIPTION</span>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-start', flex: 1 }}>
          <span style={{ color: 'grey', fontSize: 13, letterSpacing: 0.3 }}>{ description }</span>
        </div>
      </div>

      <Line style={{ marginBottom: 15, marginTop: 15 }}/>

      <div className='flex-container-row'>
        <div className='flex-container-column'>
          <span style={{ color: '#575757', fontSize: 11, fontWeight: 'bold', marginBottom: 5 }}>DON'T CHARGE CLIENT</span>
          <Switch on={this.state.noCharge} small={true} onClick={() => { this.setState({ ...this.state, noCharge: !this.state.noCharge }) }} />
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', flex: 1 }}>
          <span className='button-default'
                onClick={ () => {
                  this.setState({ ...this.state, start_loading: true })
                  this.startConsultationAction();
                }}
                style={{
                  letterSpacing: 0.8, fontSize: 11, fontWeight: 'bold', color: 'white', paddingTop: 22, paddingBottom: 22, paddingRight: 28, paddingLeft: 28, borderRadius: 5
                }}><div className='flex-container-row' style={{ alignItems: 'center', height: 18 }}>{ this.state.start_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 10 }} /> : null }START CONSULTATION</div></span>
        </div>
      </div>
    </div>
  }

  renderStartConsultationSection = () => {

    let user       = this.props.user    && this.props.user.user ? this.props.user.user : null;
    let practiceId = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';

    return <div className="flex-container-row" style={{ paddingTop: 20, alignItems: 'flex-start' }}>
        <div className="standard-container" style={{ width: 400, minWidth: 400 }}>
          <Header title='Details' icon='fas fa-tasks' />

          { this.renderLocationSection()      }
          <Line style={{ backgroundColor: '#f5f5f5' }}/>
          { this.renderClientSection()      }
          <Line style={{ backgroundColor: '#f5f5f5' }}/>
          { this.renderPatientSection()     }
          <Line style={{ backgroundColor: '#f5f5f5' }}/>
          { this.renderProviderSection()    }
          <Line style={{ backgroundColor: '#f5f5f5' }}/>
          { this.renderSubjectSection()     }
          <Line style={{ backgroundColor: '#f5f5f5' }}/>
          { this.renderDescriptionSection() }

        </div>
        <div className="standard-container" style={{ width: 400, minWidth: 400 }}>
          <Header title='Consultation Summary' icon='fas fa-clipboard' />

          { this.renderSummarySections() }

        </div>
    </div>
  }

  render() {

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Start Consultation" />
        { this.renderStartConsultationSection() }
        { this.renderModal() }
      </div>
    );
  }

  renderModal = () => {
    let display_modal = this.state.display_modal;
    let modal_type    = this.state.modal_type;

    return <Modal show={display_modal} onHide={ () => { this.closeModal() }}>
      { modal_type === 'location'    ? this.renderLocationModal() : null }
      { modal_type === 'client'      ? this.renderClientModal()   : null }
      { modal_type === 'provider'    ? this.renderProviderModal() : null }
      { modal_type === 'patient'     ? this.renderPatientsModal() : null }
      { modal_type === 'subject'     ? this.renderSubjectModal()  : null }
      { modal_type === 'description' ? this.renderDescriptionModal() : null }
    </Modal>
  }

  renderLocationModal = () => {
    let modal_title = 'Select a Location';
    let all_locations = this.state.locations || [];

    let location_rows = all_locations.map((location, index) => {
      let name           = location.name;
      let street_address = location.street_address;
      let city           = location.city;
      let zipcode        = location.zipcode;
      let is_last        = index === all_locations.length -1;
      return <div className='flex-container-column' key={location._id}>
        <div className='flex-container-row standard-selection-row'
             style={{ justifyContent: 'space-between', padding: 15 }}
             onClick={ () => {
               this.setState({ ...this.state, selected_location: location, selected_client: null, selected_patient: null, display_modal: false, modal_type: '', selected_provider: null })
             }}>
          <div className='flex-container-column'>
            <span style={{ fontSize: 14, color: '#575757' }}>{ name }</span>
            <span style={{ fontSize: 13, color: 'grey' }}>{ street_address }</span>
            <span style={{ fontSize: 13, color: 'grey' }}>{ city + ', ' + zipcode }</span>
          </div>
        </div>
        <Line hide={is_last} style={{ backgroundColor: '#f5f5f5' }} />
      </div>
    }).filter((row) => { return row });

    return <div className='flex-container-column' style={{  }}>
      <div className='flex-container-row' style={{ padding: 15, marginBottom: 0, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>{ modal_title }</span>
        <span className='instant-cancel-button' onClick={ () => { this.closeModal() }}>
          <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <Line />
      <div>
        { location_rows }
        { location_rows.length === 0 ? <div style={{ padding: 15, textAlign: 'center', color: 'grey', fontSize: 14, marginTop: 25, marginBottom: 25 }}>This practice does not have any locations yet.</div> : null }
      </div>
    </div>
  }

  renderClientModal = () => {
    let all_clients = this.state.all_clients || [];
    let location    = this.state.selected_location || {};
    let modal_title = 'Select a Client from ' + location.name;
    let search_results = this.state.client_search_results || [];

    let user_rows   = search_results.map((client, index) => {
      let name  = StringUtils.displayName(client);
      let email = client.email ? client.email.toLowerCase() : client.email;
      return <div className='flex-container-column' key={client._id}>
        <div className='flex-container-column standard-selection-row'
             style={{ padding: 15, paddingTop: 8, paddingBottom: 8 }}
             onClick={ () => {
               this.setState({ ...this.state, selected_client: client, selected_patient: null, display_modal: false, client_search_term: '', modal_type: '', client_search_results: [], client_patients: [] })
             }}>
          <span style={{ color: '#575757', fontSize: 13 }}>{ name  }</span>
          <span style={{ color: 'grey',    fontSize: 13, marginTop: -3 }}>{ email }</span>
        </div>
        <Line style={{ backgroundColor: '#f5f5f5' }}/>
      </div>
    })

    return <div className='flex-container-column' style={{  }}>
      <div className='flex-container-row' style={{ padding: 15, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>{ modal_title }</span>
        <span className='instant-cancel-button' onClick={ () => { this.closeModal() }}>
          <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <Line />
      <div style={{  }}>
        <div className='flex-container-row' style={{ alignItems: 'center', padding: 15, paddingTop: 10, paddingBottom: 10 }}>
          <span className='fas fa-search' style={{ marginRight: 10, color: '#1dc2ff', fontSize: 16 }} />
          <Input placeholder="Search Client Name or Email"
                 value={this.state.client_search_term}
                 className='instant-input-default'
                 style={{ flex: 1, height: 38, fontSize: 14 }}
                 onChange={ (event) => {
                   this.setState({ ...this.state, client_search_term: event.target.value })
                   this.props.consultationsActions.clientSearch(this.state.token, this.state.selected_location._id, this.state.practice_id, event.target.value, (results) => { this.setState({ ...this.state, client_search_results: results}) });
                 }}
                />
        </div>
        <Line />
        <div className='flex-container-column' style={{ borderRadius: 5, overflow: 'hidden' }}>
          { user_rows }
        </div>
        { user_rows.length === 0 ? <div style={{ textAlign: 'center', paddingTop: 50, paddingBottom: 60, color: 'grey', fontSize: 14 }}>No users to display</div> : null }
      </div>
    </div>
  }

  renderPatientsModal = () => {
    let client      = this.state.selected_client || {};
    let modal_title = StringUtils.displayName(client) + "'s Animals";
    let patients    = this.state.client_patients || [];

    const genderKeys = {
      'MALE': 'Male',
      'FEMALE': 'Female',
      'MN': 'Male Neutered',
      'FS': 'Female Spayed',
    }

    let patient_rows = patients.map((patient, index) => {
      let patient_details = ArrayUtils.getSingleObject(patient.patient_details)
      let name            = StringUtils.displayName(patient_details);
      let details_string  = genderKeys[patient_details.gender] + ' | ' + patient_details.type + ' | ' + patient_details.breed + ' | ' + patient_details.age;
      return <div className='flex-container-column' key={patient_details._id}>
        <div className='flex-container-column standard-selection-row'
             style={{ padding: 15, paddingTop: 8, paddingBottom: 8 }}
             onClick={ () => {
               this.setState({ ...this.state, selected_patient: patient_details, display_modal: false, modal_type: '' });
             }}>
          <span style={{ color: '#575757', fontSize: 13 }}>{ name  }</span>
          <span style={{ color: 'grey', fontSize: 13 }}>{ details_string  }</span>
        </div>
        <Line style={{ backgroundColor: '#f5f5f5' }}/>
      </div>
    })

    return <div className='flex-container-column' style={{  }}>
      <div className='flex-container-row' style={{ padding: 15, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>{ modal_title }</span>
        <span className='instant-cancel-button' onClick={ () => { this.closeModal() }}>
          <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <Line />
      <div style={{  }}>
        <div className='flex-container-column' style={{ borderRadius: 5, overflow: 'hidden' }}>
          { patient_rows }
        </div>
        { patient_rows.length === 0 ? <div style={{ textAlign: 'center', paddingTop: 50, paddingBottom: 60, color: 'grey', fontSize: 14 }}>This user does not have any animals</div> : null }
      </div>
    </div>
  }

  renderProviderModal = () => {
    let location    = this.state.selected_location || {};
    let modal_title = 'Available Providers at ' + StringUtils.displayName(location);
    let providers   = this.state.eligible_providers || [];

    let provider_rows = providers.map((provider, index) => {
      let provider_details = ArrayUtils.getSingleObject(provider.user_details);
      let name             = StringUtils.displayName(provider_details);
      return <div className='flex-container-column' key={provider_details._id}>
        <div className='flex-container-column standard-selection-row'
             style={{ padding: 15, paddingTop: 8, paddingBottom: 8 }}
             onClick={ () => {
               this.setState({ ...this.state, selected_provider: provider_details, display_modal: false, modal_type: '' });
             }}>
          <span style={{ color: '#575757', fontSize: 13 }}>{ name  }</span>
        </div>
        <Line style={{ backgroundColor: '#f5f5f5' }}/>
      </div>
    })

    return <div className='flex-container-column' style={{  }}>
      <div className='flex-container-row' style={{ padding: 15, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>{ modal_title }</span>
        <span className='instant-cancel-button' onClick={ () => { this.closeModal() }}>
          <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <Line />
      <div style={{  }}>
        <div className='flex-container-column' style={{ borderRadius: 5, overflow: 'hidden' }}>
          { provider_rows }
        </div>
        { provider_rows.length === 0 ? <div style={{ textAlign: 'center', paddingTop: 50, paddingBottom: 60, color: 'grey', fontSize: 14 }}>There are no available providers at the selected location.</div> : null }
      </div>
    </div>
  }

  renderSubjectModal = () => {
    let modal_title = 'Consultation Subject';
    return <div className='flex-container-column' style={{  }}>
      <div className='flex-container-row' style={{ padding: 15, paddingBottom: 0, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>{ modal_title }</span>
        <span className='instant-cancel-button' onClick={ () => { this.closeModal() }}>
          <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <div style={{  }}>
        <div className='flex-container-column' style={{ borderRadius: 5, overflow: 'hidden' }}>
          <textarea
              placeholder="Enter Subject"
              rows="3"
              type="text"
              name="message"
              className="consultations-message-input"
              style={{ margin: 15, marginTop: 10, marginBottom: 10 }}
              value={this.state.subject}
              onChange={(event) => { this.setState({ ...this.state, subject: event.target.value  }) }}
            >
            </textarea>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', marginRight: 15, marginBottom: 15 }}>
          <div className='instant-join-session-button'
               onClick={ () => {
                 this.closeModal()
               }}>
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Done</span>
          </div>
        </div>
      </div>
    </div>
  }

  renderDescriptionModal = () => {
    let modal_title = 'Consultation Description';
    return <div className='flex-container-column' style={{  }}>
      <div className='flex-container-row' style={{ padding: 15, paddingBottom: 0, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}>{ modal_title }</span>
        <span className='instant-cancel-button' onClick={ () => { this.closeModal() }}>
          <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
        </span>
      </div>
      <div style={{  }}>
        <div className='flex-container-column' style={{ borderRadius: 5, overflow: 'hidden' }}>
          <textarea
              placeholder="Enter Description"
              rows="3"
              type="text"
              name="message"
              className="consultations-message-input"
              style={{ margin: 15, marginTop: 10, marginBottom: 10 }}
              value={this.state.description}
              onChange={(event) => { this.setState({ ...this.state, description: event.target.value  }) }}
            >
            </textarea>
        </div>
        <div className='flex-container-column' style={{ alignItems: 'flex-end', marginRight: 15, marginBottom: 15 }}>
          <div className='instant-join-session-button'
               onClick={ () => {
                 this.closeModal()
               }}>
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>Done</span>
          </div>
        </div>
      </div>
    </div>
  }

  closeModal = () => {
    this.setState({ ...this.state, display_modal: false, modal_type: '' });
  }

  setLocations = (locations) => {
    let only_one_location = locations.length === 1;
    let selected_location = this.state.selected_location === null ? null : this.state.selected_location;
    if (only_one_location) {
      selected_location = locations[0];
    }
    this.setState({ ...this.state, locations: locations, selected_location: selected_location });
  }

  setRoles = (roles) => {
    let is_front_desk  = roles && roles.front_desk === true ? true : false;
    let provider_locs  = this.state.provider_locations || [];
    let all_locations  = this.state.locations || [];
    let selected_location = this.state.selected_location === null ? null : this.state.selected_location;

    if (is_front_desk && provider_locs.length === 1 && all_locations.length > 0) {
      let prov_loc = provider_locs[0];
      all_locations.forEach((loc, i) => {
        if (loc._id === prov_loc.practice_location_id) {
          selected_location = loc;
        }
      });
    }

    this.setState({ ...this.state, roles: roles, selected_location: selected_location });
  }

  startConsultationAction = () => {
    if (!this.state.selected_location || !this.state.selected_client || !this.state.selected_patient || !this.state.selected_provider || !this.state.subject || !this.state.description) {
      this.props.toastActions.displayInfo('All details have not been added for this consultation');
      this.setState({ ...this.state, start_loading: false });
      return;
    }

    const consultation = {
      practice_id: this.state.practice_id,
      primary_assignee: this.state.selected_provider._id,
      primary_client: this.state.selected_client._id,
      location_id: this.state.selected_location._id,
      subject: this.state.subject,
      description: this.state.description,
      patient_id: this.state.selected_patient._id,
      no_charge: this.state.noCharge,
      final_amount: 0,
    }
    let token = this.state.token;
    if (token && consultation.practice_id && consultation.primary_assignee && consultation.primary_client && consultation.location_id && consultation.subject && consultation.description && consultation.patient_id) {
      this.props.consultationsActions.createNewConsultation(token, consultation, this.successAction)
    }
  }

  setClientPatients = (patients) => {
    this.setState({ ...this.state, client_patients: patients })
  }

  setProviderLocations = (provider_locations) => {
    this.setState({ ...this.state, provider_locations: provider_locations })
  }

  successAction = () => {
    this.props.toastActions.displayInfo('Consultation Successfully Created!');
    NavigationActions.navigateBack();
  }

  setEligibleProviders = (providers) => {
    this.setState({ ...this.state, eligible_providers: providers });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationStartScreen)
